import styled from 'styled-components';
import {
  StyledButton,
  StyledButtonTransparent
} from '../../../_shared/components/Button/Styles';

export const ModalDescription = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  margin-top: 24px;
  font-style: normal;
  font-size: ${({ theme }) => theme.FONT_SIZES.BASE};
  line-height: 20px;
`;
export const StyledDeclineFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 22px;
`;

export const StyledSendToClosingButton = styled(StyledButton)`
  background: ${({ theme }) => theme.COLORS.TERTIARY};
  color: ${({ theme }) => theme.COLORS.BASE};
  padding: 10px 12px;
`;

export const StyledCancelButton = styled(StyledButtonTransparent)`
  padding: 10px 0px 0px 0px;
`;

export const StyledSendToLostButton = styled(StyledButtonTransparent)`
  padding-right: 18px;
`;
